function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoticeRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27 3H5a2 2 0 00-2 2v18a2 2 0 002 2h6l5 5 5-5h6a2 2 0 002-2V5a2 2 0 00-2-2zm0 20h-6.83L16 27.17 11.83 23H5V5h22v18z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21a1.869 1.869 0 01-1.36-.55 1.88 1.88 0 010-2.7 1.9 1.9 0 011.36-.54 1.93 1.93 0 011.37.54 1.881 1.881 0 010 2.7A1.89 1.89 0 0116 21zm-1.25-5.29L14.54 7h3l-.24 8.71h-2.55z",
    fill: props.color
  }));
}

export default SvgIconNoticeRexOutline;